<template>
    <div>
        <div class="mb-3">
        {{ customMessage ? $t(customMessage, customMessageParams) : $t('deletePromptQuestion') }}
          <slot/>
        </div>
        <div class="w-100"/>
        <Button @click="$emit('confirm')">{{ $t(buttonConfirmText) }}</Button><Button @click="$emit('abort')">{{ $t(buttonAbortText) }}</Button>
    </div>
</template>

<script>
    import Button from "./Button";

    export default {
        name: "DeletePrompt",
        components: {
            Button,
        },
        props: {
            customMessage: {type: String, default: ''},
            customMessageParams: {type: Object, default: () => {return {}}},
            buttonConfirmText: {type: String, default: 'yes'},
            buttonAbortText: {type: String, default: 'abort'}
        }
    }
</script>

<style scoped>
    .button {
        margin-right: 15px;
    }
</style>